
export default class CloseMapCharacterMenuEvent {
    /**
     * @constructor
     * @param {string} type 
     */
    constructor(type) {
        this.type = type;
    }
}

CloseMapCharacterMenuEvent.CLOSE_ALL = "CloseMapCharacterMenuEvent.CLOSE_ALL";